import AWS from 'aws-sdk'

export const s3 = new AWS.S3({
    apiVersion: '2006-03-01',
    region: 'ap-southeast-1',
    accessKeyId: 'AKIAJJNHE4KOX3G5OJCA',
    secretAccessKey: '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',
});


// var params = {
//     Bucket: 'pdf-inventory',
//     Key: `invoice/${fileName}.pdf`,
//     Body: fs.readFileSync(path),
//     // ContentType: "application/pdf",
//     // ContentDisposition: 'inline'
// };

// s3.upload(params, (err, res) => {
//     console.log("upload complete pdf")
//     if (err) {
//         callback(err);
//         return console.log(err)
//     }

//     cbSuccess(null, {
//         statusCode: 200,
//         headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Access-Control-Allow-Credentials': true,
//         },
//         body: JSON.stringify({
//             ...res
//         })

//     })
// })